/**
 * 诊断相关文案配置
 */
export default {
  // 诊断名称
  name: 'Admission Test',

}
